import { orchestrator } from 'satcheljs';
import { connectOWAAccount } from 'owa-accounts-service';
import { startAddingAccount } from '../actions/internalActions';
import { AccountsEditorState } from '../store/schema/AccountsEditorState';
import setAccountsEditorState from '../mutators/setAccountsEditorState';
import setSelectedAccountProvider from '../mutators/setSelectedAccountProvider';
import getAccountsEditorSource from '../selectors/getAccountsEditorSource';

orchestrator(startAddingAccount, async ({ accountProviderType, isReconnectFlow }) => {
    setSelectedAccountProvider(accountProviderType);
    setAccountsEditorState(AccountsEditorState.Adding);
    connectOWAAccount(accountProviderType, getAccountsEditorSource(), isReconnectFlow);
});
